

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, setDoc, collection, addDoc, query, where, getDocs, Timestamp, updateDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../../firebase/firebaseConfig';
import './ProductDetailsPage.css';
import { FirestoreService } from '../../firebase/firestoreService';
import FloatingActions from '../FloatingActions/FloatingActions';
import ProductDetails from './ProductDetails';


const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';


const ProductDetailsPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const auth = getAuth();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [inCart, setInCart] = useState(false);
  const [inWishList, setInWishList] = useState(false);
  const [isCompared, setIsCompared] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [loginMode, setLoginMode] = useState('login');
  const [orderProcessing, setOrderProcessing] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderError, setOrderError] = useState(null);
  const [pointsEarned, setPointsEarned] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [usePointsDiscount, setUsePointsDiscount] = useState(false);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [pointsDiscountAmount, setPointsDiscountAmount] = useState(0);
  const [pointsMessage, setPointsMessage] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [deliverySurcharge, setDeliverySurcharge] = useState(0);
  const [authenticationRequired, setAuthenticationRequired] = useState(false);
  const [notificationSent, setNotificationSent] = useState(false);
  const [showBulkEnquiryModal, setShowBulkEnquiryModal] = useState(false);
  const [showTimeCutoff, setShowTimeCutoff] = useState(false);
  const [bulkEnquiryForm, setBulkEnquiryForm] = useState({
    name: '',
    email: '',
    phone: '',
    quantity: 10,
    message: '',
    companyName: ''
  });
  const [bulkEnquirySubmitting, setBulkEnquirySubmitting] = useState(false);
  const [bulkEnquirySuccess, setBulkEnquirySuccess] = useState(false);
  const [bulkEnquiryError, setBulkEnquiryError] = useState(null);

  // New state variables for location fetching
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [fullAddressData, setFullAddressData] = useState(null);


  // Delivery calculation states
  const [deliveryDistance, setDeliveryDistance] = useState(0);
  const [isCalculatingDelivery, setIsCalculatingDelivery] = useState(false);
  const [deliveryError, setDeliveryError] = useState('');
  const [deliveryCharge, setDeliveryCharge] = useState(0); // Base delivery charge based on distance

  const BULK_ENQUIRY_PHONE = "8861938913";
  const ADMIN_NOTIFICATION_PHONE = "8861938913";

  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
    name: '',
    phone: '',
  });

  const [orderForm, setOrderForm] = useState({
    name: '',
    phone: '',
    deliveryAddress: '',
    paymentMethod: 'online',
    deliveryOption: 'standard',
  });

  // Updated inventory location and delivery constants
  const INVENTORY_LOCATION = "SP Road, Bangalore North, Bangalore, Karnataka 560002, India";
  const DELIVERY_RATE_PER_KM = 45; // ₹45 per kilometer
  const BASE_DELIVERY_CHARGE = 50; // Minimum delivery charge
  const MAX_DELIVERY_CHARGE = 500; // Maximum delivery charge
  const FREE_DELIVERY_THRESHOLD = 2000; // Free delivery above this amount


  const CUTOFF_HOUR = 15; // 3:00 PM (24-hour format)
  const BUSINESS_PHONE = "8861938913"

  const isOrderingAllowed = () => {
    const now = new Date();
    const currentHour = now.getHours();
    return currentHour < CUTOFF_HOUR; // Returns true if before 3:00 PM
  };


  // Function to show the time cutoff modal
  const showTimeCutoffModal = () => {
    setShowTimeCutoff(true);
  };

  // Function to close the time cutoff modal
  const closeTimeCutoffModal = () => {
    setShowTimeCutoff(false);
  };

  // Delivery surcharge rates for different delivery options
  const DELIVERY_SURCHARGE_RATES = {
    quick: 80, // ₹80 extra for quick delivery
    express: 150, // ₹150 extra for express delivery
    standard: 60, // ₹60 for standard delivery
    normal: 60, // ₹60 for normal delivery
    late: 0 // No extra charge for eco delivery
  };
  const getApiBaseUrl = () => {
    // Determine the API base URL based on the environment
    const isLocalhost = window.location.hostname === 'localhost';
    const isFirebaseHosted = window.location.hostname.includes('web.app') ||
      window.location.hostname.includes('firebaseapp.com');

    let baseUrl;
    if (isLocalhost) {
      baseUrl = 'http://localhost:5000/api';
    } else if (isFirebaseHosted) {
      // Use the Firebase Functions URL when running on Firebase hosting
      baseUrl = 'https://us-central1-procart-8d2f6.cloudfunctions.net/razorpayApi/api';
    } else {
      // Fallback URL or another environment
      baseUrl = '/api';
    }

    console.log('Using Razorpay API URL:', baseUrl);
    return baseUrl;
  };
  // Load Razorpay script
  useEffect(() => {
    const loadRazorpayScript = () => {
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        script.onload = () => {
          resolve(true);
        };
        script.onerror = () => {
          resolve(false);
        };
        document.body.appendChild(script);
      });
    };

    loadRazorpayScript();
  }, []);

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }


  // Calculate next business day's delivery window (9 AM to 4 PM)
  const calculateNextDayDeliveryWindow = () => {
    // Get tomorrow's date
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Set delivery window start (9 AM)
    const deliveryStart = new Date(tomorrow);
    deliveryStart.setHours(9, 0, 0, 0);

    // Set delivery window end (4 PM)
    const deliveryEnd = new Date(tomorrow);
    deliveryEnd.setHours(16, 0, 0, 0);

    return {
      scheduledDate: tomorrow,
      deliveryWindowStart: Timestamp.fromDate(deliveryStart),
      deliveryWindowEnd: Timestamp.fromDate(deliveryEnd),
      deliveryDateFormatted: tomorrow.toLocaleDateString('en-IN', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }),
      deliveryTimeFormatted: '9:00 AM - 4:00 PM'
    };
  };


  // Debounced delivery calculation
  const calculateDeliveryCharges = useCallback(
    debounce(async (address) => {
      if (!address || !address.trim()) {
        setDeliveryDistance(0);
        setDeliveryCharge(0); // Base delivery charge
        setDeliveryError('');
        return;
      }

      setIsCalculatingDelivery(true);
      setDeliveryError('');

      try {
        // First, try to calculate using a more reliable method
        const distance = await calculateDistanceUsingGeocoding(address);

        if (distance > 0) {
          const calculatedCharge = calculateBaseDeliveryFee(distance);
          setDeliveryDistance(distance);
          setDeliveryCharge(calculatedCharge); // Base delivery charge
          console.log(`Distance: ${distance.toFixed(1)} km, Base Delivery Charge: ₹${calculatedCharge}`);
        } else {
          // Fallback to estimated charges based on location patterns
          const estimatedCharge = estimateBaseDeliveryCharge(address);
          setDeliveryDistance(0);
          setDeliveryCharge(estimatedCharge); // Base delivery charge
        }
      } catch (error) {
        console.error('Error calculating delivery charges:', error);
        const estimatedCharge = estimateBaseDeliveryCharge(address);
        setDeliveryDistance(0);
        setDeliveryCharge(estimatedCharge); // Base delivery charge
        setDeliveryError('Using estimated delivery charges due to calculation error.');
      } finally {
        setIsCalculatingDelivery(false);
      }
    }, 1000),
    [product, quantity, couponApplied, usePointsDiscount]
  );


  // Get detailed address from coordinates
  const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
      );

      if (!response.ok) {
        throw new Error('Google Geocoding API error');
      }

      const data = await response.json();

      if (data.status !== 'OK' || !data.results || data.results.length === 0) {
        throw new Error('No address found for this location');
      }

      const fullResult = data.results[0];
      const formattedAddress = fullResult.formatted_address;

      return {
        fullAddress: formattedAddress,
        formattedAddress: formattedAddress,
        latitude,
        longitude
      };
    } catch (googleError) {
      console.error("Error with Google Geocoding:", googleError);
      try {
        // Fallback to another geocoding service
        const response = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );

        if (!response.ok) {
          throw new Error('Geocoding API error');
        }

        const data = await response.json();
        const locality = data.locality || '';
        const district = data.localityInfo?.administrative?.find(a => a.adminLevel === 6)?.name || '';
        const subDistrict = data.localityInfo?.administrative?.find(a => a.adminLevel === 8)?.name || '';
        const road = data.road || '';
        const street = data.street || '';
        const city = data.city || data.locality || 'Bengaluru';
        const state = data.principalSubdivision || 'Karnataka';
        const country = data.countryName || 'India';
        const postalCode = data.postcode || '';

        // Construct a more complete address from the components
        const addressComponents = [
          road || street,
          locality,
          subDistrict,
          district,
          city,
          state,
          country,
          postalCode
        ].filter(Boolean);

        const formattedAddress = addressComponents.join(', ');

        return {
          fullAddress: formattedAddress,
          formattedAddress: formattedAddress,
          latitude,
          longitude,
          city,
          state
        };
      } catch (fallbackError) {
        console.error("Error in fallback geocoding:", fallbackError);
        throw new Error('Could not determine your location. Please try again or enter your address manually.');
      }
    }
  };

  // Handle using current location
  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      setIsLocating(true);
      setLocationError('');

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

            // Set address in form
            setOrderForm(prev => ({
              ...prev,
              deliveryAddress: addressData.fullAddress
            }));
            setFullAddressData(addressData);

            // Store in localStorage for future use
            try {
              localStorage.setItem('userLocation', JSON.stringify(addressData));
            } catch (error) {
              console.error("Error saving to localStorage:", error);
            }

            setIsLocating(false);
          } catch (error) {
            console.error("Error getting detailed address:", error);
            setLocationError(error.message);
            setIsLocating(false);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          let errorMessage = 'Unable to detect location';

          if (error.code === 1) {
            errorMessage = 'Location access denied. Please enable location services.';
          } else if (error.code === 2) {
            errorMessage = 'Location unavailable. Please try again later.';
          } else if (error.code === 3) {
            errorMessage = 'Location request timed out. Please try again.';
          }

          setLocationError(errorMessage);
          setIsLocating(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      setLocationError('Geolocation is not supported by your browser');
    }
  };


  // More reliable distance calculation using geocoding
  const calculateDistanceUsingGeocoding = async (address) => {
    try {
      // Use a geocoding service to get coordinates
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(address)}&key=YOUR_OPENCAGE_API_KEY&countrycode=IN&limit=1`
      );

      if (!response.ok) {
        throw new Error('Geocoding service unavailable');
      }

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;

        // SP Road coordinates (approximate)
        const spRoadLat = 13.0067;
        const spRoadLng = 77.5667;

        const distance = calculateHaversineDistance(spRoadLat, spRoadLng, lat, lng);
        return distance;
      }

      return 0;
    } catch (error) {
      console.error('Error in geocoding:', error);
      return 0;
    }
  };

  // Haversine formula for distance calculation
  const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  };

  // Calculate base delivery fee based on distance (this is the standard delivery charge)
  const calculateBaseDeliveryFee = (distance) => {
    const subtotal = calculateSubtotal();

    // Free delivery for orders above threshold
    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 0;
    }

    let charge = Math.max(BASE_DELIVERY_CHARGE, Math.ceil(distance * DELIVERY_RATE_PER_KM));
    return Math.min(charge, MAX_DELIVERY_CHARGE);
  };

  // Calculate subtotal for delivery fee calculation
  const calculateSubtotal = () => {
    if (!product) return 0;
    const baseAmount = product.price * quantity;
    const couponDiscount = couponApplied ? baseAmount * 0.02 : 0;
    return baseAmount - couponDiscount - pointsDiscountAmount;
  };

  // Calculate delivery surcharge based on delivery option selected vs product's original delivery speed
  const calculateDeliverySurcharge = (deliveryOption) => {
    const productOriginalSpeed = mapDeliverySpeedToOption(product?.originalDeliverySpeed || 'normal');

    // If user selects the same delivery option as product's original speed, no surcharge
    if (deliveryOption === productOriginalSpeed) {
      return 0;
    }

    // Logic based on product's original delivery speed
    if (productOriginalSpeed === 'quick') {
      // Product is originally quick delivery - no surcharge for any option (all are downgrades or same)
      return 0;
    }

    if (productOriginalSpeed === 'standard' || productOriginalSpeed === 'normal') {
      // Product is originally standard/normal delivery
      if (deliveryOption === 'quick') {
        return 80; // Upgrade to quick: +₹80
      }
      if (deliveryOption === 'late') {
        return 0; // Downgrade to eco: no surcharge
      }
      return 0; // Same as original: no surcharge
    }

    if (productOriginalSpeed === 'late') {
      // Product is originally eco delivery
      if (deliveryOption === 'quick') {
        return 80; // Upgrade to quick: +₹80
      }
      if (deliveryOption === 'standard' || deliveryOption === 'normal') {
        return 60; // Upgrade to standard: +₹60
      }
      return 0; // Same as original: no surcharge
    }

    return 0; // Default: no surcharge
  };

  // Estimate base delivery charge based on location patterns
  const estimateBaseDeliveryCharge = (address) => {
    const subtotal = calculateSubtotal();

    // Free delivery for orders above threshold
    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 0;
    }

    const lowerAddress = address.toLowerCase();

    // Bangalore city center areas (closer to SP Road)
    if (lowerAddress.includes('mg road') ||
      lowerAddress.includes('brigade road') ||
      lowerAddress.includes('commercial street') ||
      lowerAddress.includes('chickpet') ||
      lowerAddress.includes('gandhi nagar') ||
      lowerAddress.includes('rajajinagar') ||
      lowerAddress.includes('basavanagudi') ||
      lowerAddress.includes('jayanagar') ||
      lowerAddress.includes('malleshwaram')) {
      return 80;
    }

    // Nearby areas
    if (lowerAddress.includes('koramangala') ||
      lowerAddress.includes('indiranagar') ||
      lowerAddress.includes('whitefield') ||
      lowerAddress.includes('hsr layout') ||
      lowerAddress.includes('btm layout') ||
      lowerAddress.includes('jp nagar') ||
      lowerAddress.includes('banashankari') ||
      lowerAddress.includes('vijayanagar')) {
      return 120;
    }

    // Outer Bangalore areas
    if (lowerAddress.includes('electronic city') ||
      lowerAddress.includes('sarjapur') ||
      lowerAddress.includes('marathahalli') ||
      lowerAddress.includes('hebbal') ||
      lowerAddress.includes('yelahanka') ||
      lowerAddress.includes('bommanahalli') ||
      lowerAddress.includes('bannerghatta') ||
      lowerAddress.includes('kengeri')) {
      return 180;
    }

    // Default charge for other Bangalore areas
    if (lowerAddress.includes('bangalore') ||
      lowerAddress.includes('bengaluru') ||
      lowerAddress.includes('karnataka')) {
      return 150;
    }

    // Outside Bangalore
    return 250;
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          setIsLoggedIn(true);
          setUserId(user.uid);
          const userDocRef = query(
            collection(db, 'users'),
            where('email', '==', user.email)
          );
          const userSnapshot = await getDocs(userDocRef);
          if (!userSnapshot.empty) {
            const firestoreUserData = userSnapshot.docs[0].data();
            const firestoreUserId = userSnapshot.docs[0].id;
            const completeUserData = {
              uid: firestoreUserId,
              email: user.email,
              name: firestoreUserData.name || user.displayName || 'User',
              phone: firestoreUserData.phone || '',
              deliveryAddress: firestoreUserData.deliveryAddress || '',
              points: firestoreUserData.points || 0,
              ...firestoreUserData
            };
            localStorage.setItem('authToken', 'demo-token-' + firestoreUserId);
            localStorage.setItem('userData', JSON.stringify(completeUserData));
            setUserData(completeUserData);
            setAvailablePoints(completeUserData.points || 0);
            setOrderForm(prev => ({
              ...prev,
              name: completeUserData.name || '',
              phone: completeUserData.phone || '',
              deliveryAddress: completeUserData.deliveryAddress || ''
            }));
          } else {
            const basicUserData = {
              uid: user.uid,
              email: user.email,
              name: user.displayName || 'User',
              points: 0
            };
            setUserData(basicUserData);
            setAvailablePoints(0);
            localStorage.setItem('authToken', 'demo-token-' + user.uid);
            localStorage.setItem('userData', JSON.stringify(basicUserData));
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          const basicUserData = {
            uid: user.uid,
            email: user.email,
            name: user.displayName || 'User',
            points: 0
          };
          setUserData(basicUserData);
          setAvailablePoints(0);
          localStorage.setItem('authToken', 'demo-token-' + user.uid);
          localStorage.setItem('userData', JSON.stringify(basicUserData));
        }
      } else {
        try {
          const storedAuthToken = localStorage.getItem('authToken');
          const storedUserData = localStorage.getItem('userData');
          if (storedAuthToken && storedUserData) {
            const parsedUserData = JSON.parse(storedUserData);
            if (parsedUserData.uid) {
              const userDocRef = doc(db, 'users', parsedUserData.uid);
              const userDoc = await getDoc(userDocRef);
              if (userDoc.exists()) {
                setIsLoggedIn(true);
                setUserId(parsedUserData.uid);
                setUserData(parsedUserData);
                setAvailablePoints(parsedUserData.points || 0);
                setOrderForm(prev => ({
                  ...prev,
                  name: parsedUserData.name || '',
                  phone: parsedUserData.phone || '',
                  deliveryAddress: parsedUserData.deliveryAddress || ''
                }));
              } else {
                localStorage.removeItem('authToken');
                localStorage.removeItem('userData');
                setIsLoggedIn(false);
                setUserId(null);
                setUserData(null);
                setAvailablePoints(0);
                loadSavedCheckoutData();
              }
            } else {
              localStorage.removeItem('authToken');
              localStorage.removeItem('userData');
              setIsLoggedIn(false);
              setUserId(null);
              setUserData(null);
              setAvailablePoints(0);
              loadSavedCheckoutData();
            }
          } else {
            setIsLoggedIn(false);
            setUserId(null);
            setUserData(null);
            setAvailablePoints(0);
            loadSavedCheckoutData();
          }
        } catch (localStorageError) {
          console.error("Error accessing localStorage:", localStorageError);
          setIsLoggedIn(false);
          setUserId(null);
          setUserData(null);
          setAvailablePoints(0);
          loadSavedCheckoutData();
        }
      }
      setAuthChecked(true);
    });
    return () => unsubscribe();
  }, [auth]);

  const loadSavedCheckoutData = () => {
    try {
      const savedCheckoutData = localStorage.getItem('checkoutUserData');
      if (savedCheckoutData) {
        const parsedData = JSON.parse(savedCheckoutData);
        setOrderForm(prev => ({
          ...prev,
          name: parsedData.name || '',
          phone: parsedData.phone || '',
          deliveryAddress: localStorage.getItem('deliveryAddress') || ''
        }));
      }
    } catch (error) {
      console.error("Error loading saved checkout data:", error);
    }
  };

  useEffect(() => {
    if (product) {
      const baseAmount = product.price * quantity;
      const couponDiscount = couponApplied ? baseAmount * 0.02 : 0;
      let pointsDiscount = 0;
      if (usePointsDiscount && isLoggedIn) {
        const maxPointsDiscount = availablePoints / 100;
        const maxAllowedDiscount = baseAmount - couponDiscount;
        pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        if (pointsDiscount > 0) {
          setPointsMessage(`Using ${Math.floor(pointsDiscount * 100)} points for ₹${pointsDiscount.toFixed(2)} discount`);
        } else {
          setPointsMessage('Not enough points for discount');
        }
        setPointsDiscountAmount(pointsDiscount);
      } else {
        setPointsDiscountAmount(0);
        setPointsMessage('');
      }
      setDiscountAmount(couponDiscount);

      // Calculate delivery surcharge based on selected delivery option
      const currentDeliverySurcharge = calculateDeliverySurcharge(orderForm.deliveryOption);
      setDeliverySurcharge(currentDeliverySurcharge);

      // Calculate total amount including base delivery charge + delivery surcharge
      setTotalAmount(baseAmount - couponDiscount - pointsDiscount + deliveryCharge + currentDeliverySurcharge);

      // Calculate points earned based on original price
      const originalAmount = product.originalPrice * quantity;
      const points = Math.floor(originalAmount * 0.1);
      setPointsEarned(points);
    }
  }, [product, quantity, couponApplied, usePointsDiscount, availablePoints, deliveryCharge, orderForm.deliveryOption, isLoggedIn]);

  // Trigger delivery calculation when delivery address changes
  useEffect(() => {
    if (orderForm.deliveryAddress) {
      calculateDeliveryCharges(orderForm.deliveryAddress);
    }
  }, [orderForm.deliveryAddress, calculateDeliveryCharges]);

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        setLoading(true);
        const categoryItemRef = doc(db, 'categoryItems', productId);
        const categoryItemSnap = await getDoc(categoryItemRef);
        if (categoryItemSnap.exists()) {
          const data = categoryItemSnap.data();
          setProduct({
            id: categoryItemSnap.id,
            ...data,
            deliverySpeed: data.deliverySpeed || 'normal',
            originalDeliverySpeed: data.deliverySpeed || 'normal',
            isQuick: data.deliverySpeed === 'quick',
            model: data.model || `M${categoryItemSnap.id.substring(0, 5)}`,
            weight: data.weight || '250g',
            price: data.price || 0,
            originalPrice: data.originalPrice || data.price || 0,
            discountPercentage: data.discountPercentage || 0,
            customSpecifications: data.customSpecifications || [],
            packagePoints: data.packagePoints || []
          });
          const deliveryOption = mapDeliverySpeedToOption(data.deliverySpeed || 'normal');
          setOrderForm(prev => ({
            ...prev,
            deliveryOption: deliveryOption
          }));
        } else {
          const productRef = doc(db, 'products', productId);
          const productSnap = await getDoc(productRef);
          if (productSnap.exists()) {
            const data = productSnap.data();
            setProduct({
              id: productSnap.id,
              ...data,
              deliverySpeed: data.deliverySpeed || 'normal',
              originalDeliverySpeed: data.deliverySpeed || 'normal',
              isQuick: data.deliverySpeed === 'quick',
              model: data.model || `M${productSnap.id.substring(0, 5)}`,
              weight: data.weight || '250g',
              price: data.price || 0,
              originalPrice: data.originalPrice || data.price || 0,
              discountPercentage: data.discountPercentage || 0,
              customSpecifications: data.customSpecifications || [],
              packagePoints: data.packagePoints || []
            });
            const deliveryOption = mapDeliverySpeedToOption(data.deliverySpeed || 'normal');
            setOrderForm(prev => ({
              ...prev,
              deliveryOption: deliveryOption
            }));
          } else {
            setError(new Error('Product not found'));
          }
        }
      } catch (err) {
        console.error("Error fetching product:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (productId) {
      fetchProductDetails();
    }
  }, [productId]);

  const mapDeliverySpeedToOption = (speed) => {
    switch (speed) {
      case 'quick':
      case 'express':
        return 'quick';
      case 'late':
        return 'late';
      case 'normal':
      default:
        return 'standard';
    }
  };

  useEffect(() => {
    if (product) {
      checkProductInCart();
      checkProductInWishList();
      checkProductInCompare();
    }
  }, [product]);

  const checkProductInCart = useCallback(() => {
    if (!product) return;
    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        const cartArray = Array.isArray(parsedCart) ? parsedCart : [];
        const existingProduct = cartArray.find(item => item.id === product.id);
        if (existingProduct) {
          setInCart(true);
          setQuantity(existingProduct.quantity || 1);
          if (existingProduct.couponApplied) {
            setCouponApplied(true);
          }
          if (existingProduct.pointsUsed > 0) {
            setUsePointsDiscount(true);
            setPointsDiscountAmount(existingProduct.pointsDiscount || 0);
          }
        } else {
          setInCart(false);
          setQuantity(1);
        }
      } catch (error) {
        console.error("Error parsing cart items:", error);
        setInCart(false);
        setQuantity(1);
      }
    } else {
      setInCart(false);
      setQuantity(1);
    }
  }, [product]);

  const checkProductInWishList = useCallback(() => {
    if (!product) return;
    const existingWishList = localStorage.getItem('wishListItems');
    if (existingWishList) {
      try {
        const parsedWishList = JSON.parse(existingWishList);
        const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];
        const existingProduct = wishListArray.find(item => item.id === product.id);
        setInWishList(!!existingProduct);
      } catch (error) {
        console.error("Error parsing wish list items:", error);
        setInWishList(false);
      }
    } else {
      setInWishList(false);
    }
  }, [product]);

  const checkProductInCompare = useCallback(() => {
    if (!product) return;
    const existingCompareList = localStorage.getItem('compareItems');
    if (existingCompareList) {
      try {
        const parsedCompareList = JSON.parse(existingCompareList);
        const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];
        const existingProduct = compareArray.find(item => item.id === product.id);
        setIsCompared(!!existingProduct);
      } catch (error) {
        console.error("Error parsing compare items:", error);
        setIsCompared(false);
      }
    } else {
      setIsCompared(false);
    }
  }, [product]);

  const dispatchCartUpdate = () => {
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  const dispatchWishlistUpdate = () => {
    const event = new Event('wishlistUpdated');
    window.dispatchEvent(event);
  };

  const dispatchCompareUpdate = () => {
    const event = new Event('compareUpdated');
    window.dispatchEvent(event);
  };

  const getCurrentCart = () => {
    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        return Array.isArray(parsedCart) ? parsedCart : [];
      } catch (error) {
        console.error("Error parsing cart items:", error);
        return [];
      }
    }
    return [];
  };

  const handleQuantityDecrease = () => {
    if (!product || quantity <= 1) {
      removeFromCart();
      setInCart(false);
      setQuantity(1);
      setPointsEarned(Math.floor(product.originalPrice * 1 * 0.1));
      return;
    }
    const currentCart = getCurrentCart();
    const existingItemIndex = currentCart.findIndex(item => item.id === product.id);
    if (existingItemIndex >= 0) {
      const existingItem = currentCart[existingItemIndex];
      const newQuantity = existingItem.quantity - 1;
      const baseAmount = product.price * newQuantity;
      const couponDiscount = couponApplied ? baseAmount * 0.01 : 0;
      let pointsDiscount = 0;

      if (isLoggedIn && userId && existingItem.pointsUsed > 0 && usePointsDiscount) {
        const newPointsBalance = (availablePoints || 0) + (existingItem.pointsUsed / existingItem.quantity);
        updateUserPoints(newPointsBalance);
        const maxPointsDiscount = newPointsBalance / 100;
        const maxAllowedDiscount = baseAmount - couponDiscount;
        pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
      }

      const updatedCart = [...currentCart];
      updatedCart[existingItemIndex] = {
        ...existingItem,
        quantity: newQuantity,
        pointsUsed: usePointsDiscount ? Math.floor(pointsDiscount * 100) : 0,
        pointsDiscount: pointsDiscount,
      };
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      setQuantity(newQuantity);
      setPointsEarned(Math.floor(product.originalPrice * newQuantity * 0.1));
      dispatchCartUpdate();
    }
  };

  const updateCartQuantity = (newQuantity) => {
    if (!product) return;
    const currentCart = getCurrentCart();
    const existingProductIndex = currentCart.findIndex(item => item.id === product.id);
    if (existingProductIndex >= 0) {
      const existingItem = currentCart[existingProductIndex];
      const oldQuantity = existingItem.quantity;
      if (newQuantity > oldQuantity) {
        const updatedCart = [...currentCart];
        updatedCart[existingProductIndex].quantity = newQuantity;
        localStorage.setItem('cartItems', JSON.stringify(updatedCart));
        dispatchCartUpdate();
      } else if (newQuantity < oldQuantity) {
        handleQuantityDecrease();
      }
    }
    setQuantity(newQuantity);
    setPointsEarned(Math.floor(product.originalPrice * newQuantity * 0.1));
  };

  const removeFromCart = () => {
    if (!product) return;
    const currentCart = getCurrentCart();
    const itemToRemove = currentCart.find(item => item.id === product.id);
    const updatedCart = currentCart.filter(item => item.id !== product.id);
    if (isLoggedIn && userId && itemToRemove && itemToRemove.pointsUsed > 0) {
      const userPoints = availablePoints || 0;
      const newPointsBalance = userPoints;
      updateUserPoints(userPoints);
      console.log(`Restored ${itemToRemove.pointsUsed} points. New balance: ${newPointsBalance}`);
    }
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    setPointsEarned(0);
    setUsePointsDiscount(false);
    setPointsDiscountAmount(0);
    dispatchCartUpdate();
  };

  const handleAddToCart = () => {
    if (!product) return;
    const currentCart = getCurrentCart();
    const existingProductIndex = currentCart.findIndex(item => item.id === product.id);
    const basePrice = product.price || 0;
    const discountedPrice = couponApplied ? basePrice * 0.98 : basePrice;
    let updatedCart;
    if (existingProductIndex >= 0) {
      updatedCart = [...currentCart];
      updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + quantity;
      updatedCart[existingProductIndex].price = discountedPrice;
      updatedCart[existingProductIndex].couponApplied = couponApplied;
      updatedCart[existingProductIndex].pointsDiscount = usePointsDiscount ? pointsDiscountAmount : 0;
      updatedCart[existingProductIndex].pointsUsed = usePointsDiscount ? Math.floor(pointsDiscountAmount * 100) : 0;
    } else {
      const cartItem = {
        id: product.id,
        name: product.name,
        price: discountedPrice,
        originalPrice: product.originalPrice || product.price || 0,
        discountPercentage: product.discountPercentage || 0,
        quantity: quantity,
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        deliverySpeed: product.deliverySpeed || 'normal',
        originalDeliverySpeed: product.deliverySpeed || 'normal',
        couponApplied: couponApplied,
        pointsDiscount: usePointsDiscount ? pointsDiscountAmount : 0,
        pointsUsed: usePointsDiscount ? Math.floor(pointsDiscountAmount * 100) : 0
      };
      updatedCart = [...currentCart, cartItem];
    }
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    setInCart(true);
    if (isLoggedIn && userId) {
      FirestoreService.trackCartAdd(product, quantity, userId, 'categoryItem');
    }
    dispatchCartUpdate();
  };

  const updateUserPoints = async (newPointsBalance) => {
    if (!isLoggedIn || !userId) return;
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        points: newPointsBalance
      });
      setAvailablePoints(newPointsBalance);
      if (userData) {
        const updatedUserData = {
          ...userData,
          points: newPointsBalance
        };
        setUserData(updatedUserData);
        localStorage.setItem('userData', JSON.stringify(updatedUserData));
      }
      console.log(`Updated user points balance to ${newPointsBalance}`);
    } catch (error) {
      console.error("Error updating user points:", error);
    }
  };

  const handleCompare = () => {
    if (!product) return;
    const existingCompareList = localStorage.getItem('compareItems');
    let compareList = [];
    if (existingCompareList) {
      try {
        compareList = JSON.parse(existingCompareList);
        if (!Array.isArray(compareList)) compareList = [];
      } catch (error) {
        console.error("Error parsing compare list:", error);
      }
    }
    if (!isCompared) {
      compareList.push({
        id: product.id,
        name: product.name,
        price: product.price || 0,
        originalPrice: product.originalPrice || product.price || 0,
        discountPercentage: product.discountPercentage || 0,
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        description: product.description || '',
        fullDescription: product.fullDescription || '',
        category: product.category || '',
        material: product.material || '',
        dimensions: product.dimensions || '',
        weight: product.weight || '',
        warranty: product.warranty || '',
        model: product.model || product.id.substring(0, 6),
        deliverySpeed: product.deliverySpeed || 'normal',
        microcontroller: product.microcontroller || '-',
        operatingVoltage: product.operatingVoltage || '-',
        inputVoltageRecommended: product.inputVoltageRecommended || '-',
        inputVoltageLimits: product.inputVoltageLimits || '-',
        digitalIOPins: product.digitalIOPins || '-',
        analogInputPins: product.analogInputPins || '-',
        pwmChannels: product.pwmChannels || '-',
        clockSpeed: product.clockSpeed || '-',
        flashMemory: product.flashMemory || '-',
        sram: product.sram || '-',
        eeprom: product.eeprom || '-',
        usbInterface: product.usbInterface || '-',
        communicationInterfaces: product.communicationInterfaces || '-',
        operatingTemperature: product.operatingTemperature || '-',
        powerConsumption: product.powerConsumption || '-',
        ledIndicators: product.ledIndicators || '-',
        customSpecifications: product.customSpecifications || []
      });
      setIsCompared(true);
      if (isLoggedIn && userId) {
        FirestoreService.trackCompareAdd(product, userId);
      }
    } else {
      compareList = compareList.filter(item => item.id !== product.id);
      setIsCompared(false);
      if (isLoggedIn && userId) {
        FirestoreService.trackCompareRemove(product.id, userId);
      }
    }
    localStorage.setItem('compareItems', JSON.stringify(compareList));
    dispatchCompareUpdate();
  };

  const handleAddToWishList = () => {
    if (!product) return;
    const existingWishList = localStorage.getItem('wishListItems');
    let wishList = [];
    if (existingWishList) {
      try {
        wishList = JSON.parse(existingWishList);
        if (!Array.isArray(wishList)) wishList = [];
      } catch (error) {
        console.error("Error parsing wish list:", error);
      }
    }
    if (!inWishList) {
      wishList.push({
        id: product.id,
        name: product.name,
        price: product.price || 0,
        originalPrice: product.originalPrice || product.price || 0,
        discountPercentage: product.discountPercentage || 0,
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        description: product.description || '',
        fullDescription: product.fullDescription || '',
        category: product.category || '',
        material: product.material || '',
        dimensions: product.dimensions || '',
        weight: product.weight || '',
        warranty: product.warranty || '',
        deliverySpeed: product.deliverySpeed || 'normal',
        customSpecifications: product.customSpecifications || [],
        packagePoints: product.packagePoints || []
      });
      setInWishList(true);
      if (isLoggedIn && userId) {
        FirestoreService.trackWishlistAdd(product, userId);
      }
    } else {
      wishList = wishList.filter(item => item.id !== product.id);
      setInWishList(false);
      if (isLoggedIn && userId) {
        FirestoreService.trackWishlistRemove(product.id, userId);
      }
    }
    localStorage.setItem('wishListItems', JSON.stringify(wishList));
    dispatchWishlistUpdate();
  };

  const handleBuyNow = async () => {
    // Remove time check and proceed directly
    if (!authChecked) {
      setLoading(true);
      let count = 0;
      const authCheckInterval = setInterval(() => {
        if (authChecked || count > 30) {
          clearInterval(authCheckInterval);
          setLoading(false);
          checkUserAndProceed();
        }
        count++;
      }, 100);
    } else {
      checkUserAndProceed();
    }
  };

  const checkUserAndProceed = async () => {
    if (isLoggedIn && userId) {
      setShowOrderModal(true);
      return;
    }
    const currentUser = auth.currentUser;
    if (currentUser) {
      setIsLoggedIn(true);
      setUserId(currentUser.uid);
      if (!userData) {
        try {
          const userDocRef = query(
            collection(db, 'users'),
            where('email', '==', currentUser.email)
          );
          const userSnapshot = await getDocs(userDocRef);
          if (!userSnapshot.empty) {
            const preorderData = userSnapshot.docs[0].data();
            const preorderUserId = userSnapshot.docs[0].id;
            const completeUserData = {
              uid: preorderUserId,
              email: currentUser.email,
              name: preorderData.name || currentUser.displayName || 'User',
              phone: preorderData.phone || '',
              deliveryAddress: preorderData.deliveryAddress || '',
              points: preorderData.points || 0,
              ...preorderData
            };
            setUserData(completeUserData);
            setAvailablePoints(completeUserData.points || 0);
            setOrderForm(prev => ({
              ...prev,
              name: completeUserData.name || '',
              phone: completeUserData.phone || '',
              deliveryAddress: completeUserData.deliveryAddress || ''
            }));
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
      setShowOrderModal(true);
      return;
    }
    try {
      const storedAuthToken = localStorage.getItem('authToken');
      const storedUserData = localStorage.getItem('userData');
      if (storedAuthToken && storedUserData) {
        const parsedUserData = JSON.parse(storedUserData);
        if (parsedUserData.uid) {
          const userDocRef = doc(db, 'users', parsedUserData.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            setIsLoggedIn(true);
            setUserId(parsedUserData.uid);
            setUserData(parsedUserData);
            setAvailablePoints(parsedUserData.points || 0);
            setOrderForm(prev => ({
              ...prev,
              name: parsedUserData.name || '',
              phone: parsedUserData.phone || '',
              deliveryAddress: parsedUserData.deliveryAddress || ''
            }));
            setShowOrderModal(true);
            return;
          }
        }
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
    setShowLoginModal(true);
  };

  // Try to load stored location data
  const loadSavedLocation = () => {
    const savedLocation = localStorage.getItem('userLocation');
    if (savedLocation) {
      try {
        const parsedLocation = JSON.parse(savedLocation);
        setFullAddressData(parsedLocation);
        if (!orderForm.deliveryAddress) {
          setOrderForm(prev => ({
            ...prev,
            deliveryAddress: parsedLocation.fullAddress || parsedLocation.formattedAddress || ''
          }));
        }
      } catch (error) {
        console.error('Error parsing saved location:', error);
      }
    }
  };

  // Call this in an appropriate useEffect, such as when setting initial form data
  // For example, when userData is loaded
  useEffect(() => {
    if (userData) {
      setOrderForm(prev => ({
        ...prev,
        name: userData.name || '',
        phone: userData.phone || '',
        deliveryAddress: userData.deliveryAddress || ''
      }));

      // If no delivery address is set, try to load from saved location
      if (!userData.deliveryAddress) {
        loadSavedLocation();
      }
    } else {
      loadSavedLocation();
    }
  }, [userData]);



  const sendOrderNotification = async (orderData) => {
    try {
      const customerMessage = `Thank you for your order!\n\nOrder Details:\nProduct: ${orderData.productName}\nQuantity: ${orderData.quantity}\nTotal Amount: ₹${orderData.totalAmount.toFixed(2)}\nDelivery Option: ${getDeliveryOptionDetails(orderData.deliveryOption).label}\n\nYour order will be delivered on ${orderData.deliveryDateFormatted} between ${orderData.deliveryTimeFormatted}.\n\nFor any questions, please contact us at ${BUSINESS_PHONE}.`;

      const adminMessage = `New Order Received!\n\nOrder ID: ${orderData.orderId}\nProduct: ${orderData.productName}\nQuantity: ${orderData.quantity}\nTotal: ₹${orderData.totalAmount.toFixed(2)}\nCustomer: ${orderData.customerName}\nPhone: ${orderData.customerPhone}\nAddress: ${orderData.deliveryAddress}\nDelivery: ${getDeliveryOptionDetails(orderData.deliveryOption).label} (Scheduled for ${orderData.deliveryDateFormatted})\nPayment: ${orderData.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Online Payment'}\nInventory Location: ${INVENTORY_LOCATION}`;
      const notificationData = {
        type: 'orderPlaced',
        orderData: orderData,
        userPhone: orderData.customerPhone,
        adminPhone: ADMIN_NOTIFICATION_PHONE,
        businessPhone: BUSINESS_PHONE,
        notificationType: 'whatsapp',
        customerMessage: customerMessage,
        adminMessage: adminMessage,
        status: 'pending',
        createdAt: Timestamp.now()
      };

      const notificationRef = await addDoc(collection(db, 'notifications'), notificationData);
      setNotificationSent(true);

      setTimeout(() => {
        // Send to business number instead of admin phone
        const encodedBusinessMessage = encodeURIComponent(adminMessage);
        window.open(`https://api.whatsapp.com/send?phone=${BUSINESS_PHONE}&text=${encodedBusinessMessage}`, 'business_whatsapp', 'width=800,height=600');

        updateDoc(doc(db, 'notifications', notificationRef.id), {
          businessNotificationSent: true,
          businessSentAt: Timestamp.now()
        });

        console.log(`WhatsApp notification sent to business: ${BUSINESS_PHONE}`);

        // Send to customer after a delay
        setTimeout(() => {
          const encodedCustomerMessage = encodeURIComponent(customerMessage);
          window.open(`https://api.whatsapp.com/send?phone=${orderData.customerPhone}&text=${encodedCustomerMessage}`, 'customer_whatsapp', 'width=800,height=600');

          updateDoc(doc(db, 'notifications', notificationRef.id), {
            status: 'sent',
            customerNotificationSent: true,
            customerSentAt: Timestamp.now(),
            sentAt: Timestamp.now()
          });

          console.log(`WhatsApp notification sent to customer: ${orderData.customerPhone}`);
        }, 1000);
      }, 500);

      return true;
    } catch (error) {
      console.error("Error processing order notification:", error);
      return false;
    }
  };

  const handleBulkEnquiryFormChange = (e) => {
    const { name, value } = e.target;
    setBulkEnquiryForm(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleDirectWhatsAppEnquiry = () => {
    if (!product) return;
    const message = `Hello, I'm interested in placing a bulk order for "${product.name}" (Product ID: ${product.id}). Please provide bulk pricing information.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${BUSINESS_PHONE}?text=${encodedMessage}`, '_blank');
    if (isLoggedIn && userId) {
      FirestoreService.trackBulkEnquiry && FirestoreService.trackBulkEnquiry(product, userId);
    }
  };

  const handleBulkEnquirySubmit = async (e) => {
    e.preventDefault();
    setBulkEnquirySubmitting(true);
    setBulkEnquiryError(null);
    try {
      if (!bulkEnquiryForm.name.trim() || !bulkEnquiryForm.email.trim() || !bulkEnquiryForm.phone.trim()) {
        throw new Error('Please fill in all required fields');
      }
      const bulkEnquiryData = {
        productId: product.id,
        productName: product.name,
        customerName: bulkEnquiryForm.name,
        customerEmail: bulkEnquiryForm.email,
        customerPhone: bulkEnquiryForm.phone,
        companyName: bulkEnquiryForm.companyName,
        requestedQuantity: bulkEnquiryForm.quantity,
        message: bulkEnquiryForm.message,
        userId: isLoggedIn ? userId : null,
        status: 'pending',
        createdAt: Timestamp.now()
      };
      await addDoc(collection(db, 'bulkEnquiries'), bulkEnquiryData);
      setBulkEnquirySuccess(true);
      setTimeout(() => {
        setShowBulkEnquiryModal(false);
        setBulkEnquirySuccess(false);
        setBulkEnquiryForm({
          name: '',
          email: '',
          phone: '',
          quantity: 10,
          message: '',
          companyName: ''
        });
      }, 3000);
    } catch (error) {
      console.error('Bulk enquiry submission error:', error);
      setBulkEnquiryError(error.message);
    } finally {
      setBulkEnquirySubmitting(false);
    }
  };

  const handleCouponToggle = () => {
    setCouponApplied(!couponApplied);
  };

  const handlePointsToggle = () => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
      return;
    }
    setUsePointsDiscount(!usePointsDiscount);
  };

  const handleLoginFormChange = (e) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOrderFormChange = (e) => {
    const { name, value } = e.target;
    setOrderForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const toggleLoginMode = () => {
    setLoginMode(prev => prev === 'login' ? 'signup' : 'login');
  };

  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    try {
      if (loginMode === 'login') {
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', loginForm.email));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          alert('User not found. Please sign up first.');
          setLoginMode('signup');
          return;
        }
        const userData = querySnapshot.docs[0].data();
        const userId = querySnapshot.docs[0].id;
        await updateDoc(doc(db, 'users', userId), {
          lastLogin: Timestamp.now()
        });
        localStorage.setItem('authToken', 'demo-token-' + userId);
        localStorage.setItem('userData', JSON.stringify({
          uid: userId,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        }));
        setIsLoggedIn(true);
        setUserId(userId);
        setUserData({
          uid: userId,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        });
        setAvailablePoints(userData.points || 0);
        setShowLoginModal(false);
        if (authenticationRequired) {
          setShowOrderModal(true);
          setAuthenticationRequired(false);
        } else {
          setShowOrderModal(true);
        }
        setOrderForm(prev => ({
          ...prev,
          name: userData.name || '',
          phone: userData.phone || '',
          deliveryAddress: userData.deliveryAddress || ''
        }));
      } else {
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', loginForm.email));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          alert('User already exists. Please login instead.');
          setLoginMode('login');
          return;
        }
        const newUserRef = await addDoc(collection(db, 'users'), {
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          emailVerified: false,
          createdAt: Timestamp.now(),
          lastLogin: Timestamp.now(),
          points: 0
        });
        const newUserId = newUserRef.id;
        localStorage.setItem('authToken', 'demo-token-' + newUserId);
        localStorage.setItem('userData', JSON.stringify({
          uid: newUserId,
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          points: 0
        }));
        setIsLoggedIn(true);
        setUserId(newUserId);
        setUserData({
          uid: newUserId,
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          points: 0
        });
        setAvailablePoints(0);
        setShowLoginModal(false);
        if (authenticationRequired) {
          setShowOrderModal(true);
          setAuthenticationRequired(false);
        } else {
          setShowOrderModal(true);
        }
        setOrderForm(prev => ({
          ...prev,
          name: loginForm.name || '',
          phone: loginForm.phone || ''
        }));
      }
    } catch (error) {
      console.error('Authentication error:', error);
      alert('Authentication failed. Please try again.');
    }
  };

  // Handle Razorpay payment
  const handleRazorpayPayment = async (orderData) => {
    try {
      setOrderProcessing(true);

      // Load Razorpay script if not already loaded
      if (!window.Razorpay) {
        const scriptLoaded = await loadRazorpayScript();
        if (!scriptLoaded) {
          throw new Error('Failed to load Razorpay SDK');
        }
      }

      // Generate a receipt ID
      const receiptId = `rcpt_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

      // Calculate the amount in paise (Razorpay uses the smallest currency unit)
      // Make sure totalAmount is the final amount in Rupees
      const amountInPaise = Math.round(totalAmount * 100);

      console.log("Opening Razorpay payment for amount:", totalAmount, "Receipt:", receiptId);

      // Configure Razorpay options - no server call needed
      const options = {
        key: 'rzp_test_psQiRu5RCF99Dp', // Your Razorpay test key
        amount: amountInPaise, // amount in paise
        currency: 'INR',
        name: 'ProCart India',
        description: `Order for ${product.name}`,
        image: product.imageUrl || 'https://via.placeholder.com/100',
        // No order_id needed for this approach
        prefill: {
          name: orderForm.name,
          email: userData?.email || '',
          contact: orderForm.phone,
        },
        notes: {
          address: orderForm.deliveryAddress,
          product_id: product.id,
          receipt: receiptId
        },
        theme: {
          color: '#3399cc',
        },
        handler: function (response) {
          // Payment successful, proceed with order
          console.log('Payment successful:', response);

          // Store payment details in your order data
          const paymentInfo = {
            paymentId: response.razorpay_payment_id,
            method: 'razorpay',
            status: 'completed',
            receiptId: receiptId
          };

          // Process the order with the payment info
          completeOrderAfterPayment(orderData, paymentInfo);
        },
        modal: {
          ondismiss: function () {
            console.log("Payment modal closed");
            setOrderProcessing(false);
          }
        }
      };

      // Initialize Razorpay directly
      const razorpay = new window.Razorpay(options);

      // Handle payment failures
      razorpay.on('payment.failed', function (response) {
        console.error('Payment failed:', response.error);
        setOrderError(`Payment failed: ${response.error.description}`);
        setOrderProcessing(false);
      });

      // Open the payment modal
      razorpay.open();

    } catch (error) {
      console.error('Razorpay error:', error);
      setOrderError('Payment initiation failed: ' + error.message);
      setOrderProcessing(false);
    }
  };

  // Make sure this function is also defined
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Add this function to complete the order after successful payment
  // Updated completeOrderAfterPayment function
  const completeOrderAfterPayment = async (orderData, paymentInfo) => {
    try {
      // Add payment info to order data
      const completeOrderData = {
        ...orderData,
        payment: paymentInfo,
        paymentStatus: 'completed',
        paymentMethod: 'online',
        paymentId: paymentInfo.paymentId,
        // For serverless approach, we don't have order verification
        // But we can still mark it as completed based on Razorpay's response
        verificationStatus: 'razorpay_direct'
      };

      // Add the order to Firestore
      const orderRef = await addDoc(collection(db, 'orders'), completeOrderData);

      // Calculate points earned based on original price
      const originalAmount = product.originalPrice * quantity;
      const calculatedPoints = Math.floor(originalAmount * 0.1);

      // Process points if necessary
      if (usePointsDiscount && orderData.pointsUsed > 0) {
        const newPointsBalance = availablePoints - orderData.pointsUsed;
        await updateUserPoints(newPointsBalance);
      }

      // Update user points with earned points
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        const currentPoints = userDoc.data().points || 0;
        let newPointsTotal;
        if (usePointsDiscount && orderData.pointsUsed > 0) {
          newPointsTotal = availablePoints + calculatedPoints;
        } else {
          newPointsTotal = currentPoints + calculatedPoints;
        }
        await updateDoc(userRef, {
          points: newPointsTotal,
          name: orderForm.name,
          phone: orderForm.phone,
          deliveryAddress: orderForm.deliveryAddress
        });
        // Update localStorage and state
        const currentUserData = JSON.parse(localStorage.getItem('userData') || '{}');
        const updatedUserData = {
          ...currentUserData,
          points: newPointsTotal,
          name: orderForm.name,
          phone: orderForm.phone,
          deliveryAddress: orderForm.deliveryAddress
        };
        localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setUserData(updatedUserData);
        setAvailablePoints(newPointsTotal);
      }

      // Send notifications
      await sendOrderNotification({
        ...completeOrderData,
        orderId: orderRef.id
      });

      // Update state to show success
      setOrderSuccess(true);
      setOrderProcessing(false);
      setPointsEarned(calculatedPoints);

      // Save checkout data
      const checkoutUserData = {
        name: orderForm.name,
        phone: orderForm.phone,
        email: userData?.email || ''
      };
      localStorage.setItem('checkoutUserData', JSON.stringify(checkoutUserData));
      localStorage.setItem('deliveryAddress', orderForm.deliveryAddress);

      // Close modal after delay
      setTimeout(() => {
        setShowOrderModal(false);
        setOrderSuccess(false);
        setNotificationSent(false);
        setUsePointsDiscount(false);
      }, 4000);
    } catch (error) {
      console.error('Order completion error:', error);
      setOrderError('Failed to complete order after payment');
      setOrderProcessing(false);
    }
  };

  // Updated handleOrderSubmit function with Razorpay integration
  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setOrderProcessing(true);
    setOrderError(null);

    try {
      if (!isLoggedIn || !userId) {
        setAuthenticationRequired(true);
        throw new Error('You must be logged in to place an order');
      }

      if (!orderForm.name.trim()) {
        throw new Error('Name is required');
      }
      if (!orderForm.phone.trim()) {
        throw new Error('Phone number is required');
      }
      if (!orderForm.deliveryAddress.trim()) {
        throw new Error('Delivery address is required');
      }

      const baseAmount = product.price * quantity;
      const couponDiscount = couponApplied ? baseAmount * 0.02 : 0;
      let pointsDiscount = 0;
      let pointsUsed = 0;

      if (usePointsDiscount && availablePoints > 0) {
        const maxPointsDiscount = availablePoints / 100;
        const maxAllowedDiscount = baseAmount - couponDiscount;
        pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        pointsUsed = Math.floor(pointsDiscount * 100);
      }

      // Calculate delivery surcharge for selected option
      const currentDeliverySurcharge = calculateDeliverySurcharge(orderForm.deliveryOption);

      const finalAmount = baseAmount - couponDiscount - pointsDiscount + deliveryCharge + currentDeliverySurcharge;

      // Calculate points earned based on original price
      const originalAmount = product.originalPrice * quantity;
      const calculatedPoints = Math.floor(originalAmount * 0.1);
      const productImageUrl = product.imageUrl || product.image || "/images/product-placeholder.jpg";

      const deliverySchedule = calculateNextDayDeliveryWindow();

      const orderData = {
        userId: userId,
        productId: product.id,
        productName: product.name,
        quantity: quantity,
        price: product.price,
        baseAmount: baseAmount,
        couponDiscount: couponDiscount,
        couponApplied: couponApplied,
        pointsDiscount: pointsDiscount,
        pointsUsed: pointsUsed,
        deliveryCharge: deliveryCharge,
        deliverySurcharge: currentDeliverySurcharge,
        deliveryDistance: deliveryDistance,
        totalAmount: finalAmount,
        pointsEarned: calculatedPoints,
        customerName: orderForm.name,
        customerPhone: orderForm.phone,
        deliveryAddress: orderForm.deliveryAddress,
        paymentMethod: orderForm.paymentMethod,
        deliveryOption: orderForm.deliveryOption,
        originalDeliveryOption: product.originalDeliverySpeed || 'normal',
        imageUrl: productImageUrl,
        status: 'pending',
        createdAt: Timestamp.now(),
        inventoryLocation: INVENTORY_LOCATION,
        // Add delivery schedule information
        scheduledDeliveryDate: deliverySchedule.scheduledDate,
        deliveryWindowStart: deliverySchedule.deliveryWindowStart,
        deliveryWindowEnd: deliverySchedule.deliveryWindowEnd,
        deliveryDateFormatted: deliverySchedule.deliveryDateFormatted,
        deliveryTimeFormatted: deliverySchedule.deliveryTimeFormatted
      };

      // Check payment method
      if (orderForm.paymentMethod === 'online') {
        // Process with Razorpay
        await handleRazorpayPayment(orderData);
      } else {
        // Cash on Delivery flow - original code
        const orderRef = await addDoc(collection(db, 'orders'), orderData);
        setOrderSuccess(true);
        setPointsEarned(calculatedPoints);

        if (usePointsDiscount && pointsUsed > 0) {
          const newPointsBalance = availablePoints - pointsUsed;
          await updateUserPoints(newPointsBalance);
        }

        await sendOrderNotification({
          ...orderData,
          orderId: orderRef.id
        });

        const userRef = doc(db, 'users', userId);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const currentPoints = userDoc.data().points || 0;
          let newPointsTotal;
          if (usePointsDiscount && pointsUsed > 0) {
            newPointsTotal = availablePoints + calculatedPoints;
          } else {
            newPointsTotal = currentPoints + calculatedPoints;
          }
          await updateDoc(userRef, {
            points: newPointsTotal,
            name: orderForm.name,
            phone: orderForm.phone,
            deliveryAddress: orderForm.deliveryAddress
          });
          const currentUserData = JSON.parse(localStorage.getItem('userData') || '{}');
          const updatedUserData = {
            ...currentUserData,
            points: newPointsTotal,
            name: orderForm.name,
            phone: orderForm.phone,
            deliveryAddress: orderForm.deliveryAddress
          };
          localStorage.setItem('userData', JSON.stringify(updatedUserData));
          setUserData(updatedUserData);
          setAvailablePoints(newPointsTotal);
        }

        const checkoutUserData = {
          name: orderForm.name,
          phone: orderForm.phone,
          email: userData?.email || ''
        };
        localStorage.setItem('checkoutUserData', JSON.stringify(checkoutUserData));
        localStorage.setItem('deliveryAddress', orderForm.deliveryAddress);

        setTimeout(() => {
          setShowOrderModal(false);
          setOrderSuccess(false);
          setNotificationSent(false);
          setUsePointsDiscount(false);
        }, 4000);
      }
    } catch (error) {
      console.error('Order submission error:', error);
      setOrderError(error.message);
      if (error.message.includes('logged in') || error.message.includes('log in') || error.message.includes('session')) {
        setTimeout(() => {
          setShowOrderModal(false);
          setShowLoginModal(true);
        }, 2000);
      }
    } finally {
      if (orderForm.paymentMethod === 'cod') {
        setOrderProcessing(false);
      }
      // For 'online' payment, orderProcessing is set to false after Razorpay flow completes
    }
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-2, { replace: true });
  };

  const getDeliveryOptionDetails = (option) => {
    switch (option) {
      case 'quick':
        return {
          label: 'Quick Delivery',
          description: 'Delivered today before 4pm',
          icon: '⚡'
        };
      case 'standard':
        return {
          label: 'Standard Delivery',
          description: 'Delivered next day',
          icon: '🚚'
        };
      case 'late':
        return {
          label: 'Eco Delivery',
          description: 'Delivered within 2-3 days',
          icon: '📦'
        };
      default:
        return {
          label: 'Standard Delivery',
          description: 'Delivered next day',
          icon: '🚚'
        };
    }
  };

  const getDeliveryInfo = (deliverySpeed) => {
    switch (deliverySpeed) {
      case 'quick':
        return {
          icon: '⚡',
          label: 'Quick Delivery',
          description: 'Delivered today'
        };
      case 'express':
        return {
          icon: '🚀',
          label: 'Express Delivery',
          description: 'Delivered within hours'
        };
      case 'late':
        return {
          icon: '🐌',
          label: 'Eco Delivery',
          description: 'Delivered in 2-3 days'
        };
      case 'normal':
      default:
        return {
          icon: '🚚',
          label: 'Standard Delivery',
          description: 'Delivered by next day'
        };
    }
  };

  const getDeliveryDisplayText = () => {
    const subtotal = calculateSubtotal();

    if (subtotal >= FREE_DELIVERY_THRESHOLD) {
      return 'FREE';
    }

    if (isCalculatingDelivery) {
      return 'Calculating...';
    }

    if (deliveryDistance > 0) {
      return `${deliveryDistance.toFixed(1)} km × ₹${DELIVERY_RATE_PER_KM}`;
    }

    return 'Estimated';
  };

  if (loading) {
    return (
      <div className="product-details-page2">
        <div className="container2">
          <div className="loading-container2">
            <div className="loading-spinner2"></div>
            <p>Loading product details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="product-details-page2">
        <div className="container2">
          <div className="error-container2">
            <div className="error-icon2">⚠️</div>
            <h2>Error Loading Product</h2>
            <p>{error?.message || "Product not found"}</p>
            <button className="go-back-btn2" onClick={handleGoBack}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  const deliveryInfo = getDeliveryInfo(product.deliverySpeed || 'normal');

  const getImageUrl = () => {
    if (product.imageUrl && !imageError) {
      return product.imageUrl;
    }
    if (product.image && !imageError) {
      return product.image;
    }
    return "/images/product-placeholder.jpg";
  };

  return (
    <div className="product-details-page2">
      <div className="container2">
        <button className="go-back-btn2" onClick={handleGoBack}>
          ← Back to Products
        </button>
        <div className="product-detail-content2">
          <div className="product-detail-header2">
            <h2>{product.name}</h2>
            <div className="product-price-container">
              {product.originalPrice > product.price ? (
                <>
                  <span className="original-price2">₹{product.originalPrice.toFixed(2)}</span>
                  <span className="discount-percentage2">-{product.discountPercentage}%</span>
                  <span className="modal-price2">₹{product.price.toFixed(2)}</span>
                </>
              ) : (
                <span className="modal-price2">₹{product.price.toFixed(2)}</span>
              )}
            </div>
          </div>
          <div className="product-detail-body2 fixed-layout">
            <div className="product-left-column">
              <div className="product-detail-image-container2">
                <img
                  src={getImageUrl()}
                  alt={product.name}
                  className="modal-image2"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/product-placeholder.jpg";
                    setImageError(true);
                  }}
                />
                <div className="modal-delivery-badge2">
                  <span className="delivery-icon2">{deliveryInfo.icon}</span>
                  <span className="delivery-label2">{deliveryInfo.label}</span>
                  <span className="delivery-description2">{deliveryInfo.description}</span>
                </div>
              </div>
              <div className="purchase-options-container2">
                <div className="purchase-options-content2">
                  <div className="coupon-section2">
                    <div className="coupon-header2">
                      <div className="coupon-label2">Coupon:</div>
                    </div>
                    {isLoggedIn && (
                      <div className="points-discount-section">
                        <div className="points-discount-header">
                          <label className="points-checkbox">
                            <input
                              type="checkbox"
                              checked={usePointsDiscount}
                              onChange={handlePointsToggle}
                              disabled={availablePoints < 100}
                            />
                            <span className="checkbox-text2">
                              Use earned points ({availablePoints} available)
                            </span>
                          </label>
                        </div>
                        {pointsMessage && usePointsDiscount && (
                          <div className="points-message">
                            {pointsMessage}
                          </div>
                        )}
                        {availablePoints < 100 && (
                          <div className="insufficient-points-message">
                            Minimum 100 points required to redeem
                          </div>
                        )}
                      </div>
                    )}
                    <div className="offers-tag2">
                      <span className="offers-icon2">🏷️</span> Offers
                    </div>
                  </div>
                  <div className="purchase-buttons2">
                    {!inCart ? (
                      <button
                        className="add-to-cart-btn2"
                        onClick={handleAddToCart}
                      >
                        Add to Cart
                      </button>
                    ) : (
                      <div className="in-cart-group2">
                        <div className="cart-status2">
                          <span className="cart-status-text2">✓ In Cart ({quantity} items)</span>
                        </div>
                        <div className="cart-quantity-controls2">
                          <button
                            className="quantity-btn2 quantity-btn-minus2"
                            onClick={handleQuantityDecrease}
                          >
                            -
                          </button>
                          <span className="quantity-display2">{quantity}</span>
                          <button
                            className="quantity-btn2 quantity-btn-plus2"
                            onClick={() => {
                              updateCartQuantity(quantity + 1);
                              setQuantity(quantity + 1);
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    )}
                    <button
                      className="buy-now-btn2"
                      onClick={handleBuyNow}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
              <div className="action-buttons-container2">
                <button
                  className={`wishlist-btn2 ${inWishList ? 'active' : ''}`}
                  onClick={handleAddToWishList}
                >
                  <span className="btn-icon2">♡</span> Add to Wishlist
                </button>
                <button
                  className={`compare-btn2 ${isCompared ? 'active' : ''}`}
                  onClick={handleCompare}
                >
                  <span className="btn-icon2">⟲</span> Add to Compare
                </button>
              </div>
            </div>
            <div className="product-right-column">
              <ProductDetails
                product={product}
                BULK_ENQUIRY_PHONE={BULK_ENQUIRY_PHONE}
                setShowBulkEnquiryModal={setShowBulkEnquiryModal}
              />
            </div>
          </div>
        </div>
      </div>
      {showLoginModal && (
        <div className="modal-overlay2" onClick={() => setShowLoginModal(false)}>
          <div className="auth-modal2" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn2" onClick={() => setShowLoginModal(false)}>×</button>
            <div className="auth-modal-header2">
              <h2>{loginMode === 'login' ? 'Login' : 'Sign Up'}</h2>
              <p>
                {loginMode === 'login'
                  ? 'Login to your account to continue'
                  : 'Create an account to place your order'}
              </p>
            </div>
            <form className="auth-form2" onSubmit={handleAuthSubmit}>
              {loginMode === 'signup' && (
                <div className="form-group2">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={loginForm.name}
                    onChange={handleLoginFormChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
              )}
              <div className="form-group2">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={loginForm.email}
                  onChange={handleLoginFormChange}
                  required
                  placeholder="Enter your email"
                />
              </div>
              <div className="form-group2">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={loginForm.password}
                  onChange={handleLoginFormChange}
                  required
                  placeholder="Enter your password"
                />
              </div>
              {loginMode === 'signup' && (
                <div className="form-group2">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={loginForm.phone}
                    onChange={handleLoginFormChange}
                    required
                    placeholder="Enter your phone number"
                    pattern="[0-9]{10}"
                    title="Please enter a valid 10-digit phone number"
                  />
                </div>
              )}
              <button type="submit" className="auth-submit-btn2">
                {loginMode === 'login' ? 'Login' : 'Sign Up'}
              </button>
            </form>
            <div className="auth-switch2">
              {loginMode === 'login' ? (
                <p>Don't have an account? <button onClick={toggleLoginMode}>Sign Up</button></p>
              ) : (
                <p>Already have an account? <button onClick={toggleLoginMode}>Login</button></p>
              )}
            </div>
          </div>
        </div>
      )}
      {showOrderModal && (
        <div className="modal-overlay2" onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}>
          <div className="order-modal2" onClick={e => e.stopPropagation()}>
            <button
              className="modal-close-btn2"
              onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}
              disabled={orderProcessing || orderSuccess}
            >
              ×
            </button>
            {orderSuccess ? (
              <div className="order-success2">
                <div className="success-icon2">✓</div>
                <h3>Order Placed Successfully!</h3>
                <p>Your order has been received and is being processed.</p>
                <p className="delivery-confirmation2">
                  {getDeliveryOptionDetails(orderForm.deliveryOption).icon} {getDeliveryOptionDetails(orderForm.deliveryOption).label}: {getDeliveryOptionDetails(orderForm.deliveryOption).description}
                </p>
                <div className="points-earned2">
                  <p>You earned <span className="points-value2">{pointsEarned} points</span> with this purchase!</p>
                </div>
                <div className="whatsapp-notification-sent2">
                  <div className="whatsapp-icon2">✉️</div>
                  <div className="notification-details2">
                    <p className="notification-title2">Notification Sent!</p>
                    <p className="notification-info2">Order details have been sent to your WhatsApp number and our admin team.</p>
                  </div>
                </div>
              </div>
            ) : (
              <form className="order-form2" onSubmit={handleOrderSubmit}>
                <div className="product-order-summary2">
                  <div className="product-order-details2">
                    <div className="product-thumbnail2">
                      <img src={getImageUrl()} alt={product.name} />
                    </div>
                    <div className="product-info2">
                      <h3 className="product-title2">{product.name}</h3>
                      <div className="product-price-qty2">
                        <span className="price2">₹{product.price.toFixed(2)}</span>
                        <span className="quantity-indicator2">× {quantity}</span>
                      </div>
                      <div className="order-total2">
                        Total: <span className="total-amount2">₹{(product.price * quantity).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="delivery-notice" style={{
                  backgroundColor: '#e8f4fd',
                  border: '1px solid #b3e0ff',
                  borderRadius: '8px',
                  padding: '12px 15px',
                  marginBottom: '15px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <div style={{ marginRight: '10px', color: '#0277bd', fontSize: '20px' }}>📦</div>
                  <div>
                    <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#0277bd' }}>Next Day Delivery</p>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                      Your order will be processed on <strong>{calculateNextDayDeliveryWindow().deliveryDateFormatted}</strong> between <strong>{calculateNextDayDeliveryWindow().deliveryTimeFormatted}</strong>
                    </p>
                  </div>
                </div>


                <div className="customer-info-section2">
                  <h3>Customer Information</h3>
                  <div className="form-row2">
                    <div className="form-group2">
                      <label htmlFor="name">Full Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={orderForm.name}
                        onChange={handleOrderFormChange}
                        required
                        placeholder="Enter your full name"
                      />
                    </div>
                    <div className="form-group2">
                      <label htmlFor="phone">Phone Number*</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={orderForm.phone}
                        onChange={handleOrderFormChange}
                        required
                        placeholder="Enter your phone number"
                        pattern="[0-9]{10}"
                        title="Please enter a valid 10-digit phone number"
                      />
                    </div>
                  </div>
                </div>
                <div className="delivery-options-section2">
                  <h3>Delivery Options</h3>
                  <div className="delivery-options2">
                    <div className="delivery-option2">
                      <label>
                        <div className="radio-container2">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="quick"
                            checked={orderForm.deliveryOption === 'quick'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom2"></span>
                        </div>
                        {/* <div className="delivery-icon-container2">
                          ⚡
                        </div> */}
                        <div className="delivery-details2">
                          <div className="delivery-name2">Quick Delivery</div>
                          <div className="delivery-description2">Delivered today before 4pm</div>
                          {(() => {
                            const surcharge = calculateDeliverySurcharge('quick');
                            const originalSpeed = mapDeliverySpeedToOption(product?.originalDeliverySpeed || 'normal');
                            if (originalSpeed === 'quick') {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>Original delivery speed</div>;
                            } else if (surcharge > 0) {
                              return <div className="delivery-surcharge2">+₹{surcharge} upgrade surcharge</div>;
                            } else {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>No additional charges</div>;
                            }
                          })()}
                        </div>
                      </label>
                    </div>
                    <div className="delivery-option2">
                      <label>
                        <div className="radio-container2">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="standard"
                            checked={orderForm.deliveryOption === 'standard'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom2"></span>
                        </div>
                        {/* <div className="delivery-icon-container2">
                          🚚
                        </div> */}
                        <div className="delivery-details2">
                          <div className="delivery-name2">Standard Delivery</div>
                          <div className="delivery-description2">Delivered next day</div>
                          {(() => {
                            const surcharge = calculateDeliverySurcharge('standard');
                            const originalSpeed = mapDeliverySpeedToOption(product?.originalDeliverySpeed || 'normal');
                            if (originalSpeed === 'standard' || originalSpeed === 'normal') {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>Original delivery speed</div>;
                            } else if (surcharge > 0) {
                              return <div className="delivery-surcharge2">+₹{surcharge} upgrade surcharge</div>;
                            } else {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>No additional charges</div>;
                            }
                          })()}
                        </div>
                      </label>
                    </div>
                    <div className="delivery-option2">
                      <label>
                        <div className="radio-container2">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="late"
                            checked={orderForm.deliveryOption === 'late'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom2"></span>
                        </div>
                        {/* <div className="delivery-icon-container2">
                          📦
                        </div> */}
                        <div className="delivery-details2">
                          <div className="delivery-name2">Eco Delivery</div>
                          <div className="delivery-description2">Delivered within 2-3 days</div>
                          {(() => {
                            const surcharge = calculateDeliverySurcharge('late');
                            const originalSpeed = mapDeliverySpeedToOption(product?.originalDeliverySpeed || 'normal');
                            if (originalSpeed === 'late') {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>Original delivery speed</div>;
                            } else if (surcharge > 0) {
                              return <div className="delivery-surcharge2">+₹{surcharge} upgrade surcharge</div>;
                            } else {
                              return <div className="delivery-surcharge2" style={{ color: 'green' }}>No additional charges</div>;
                            }
                          })()}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="delivery-address-section2">
                  <h3>Delivery Address</h3>
                  <div className="address-input-container" style={{ position: 'relative' }}>
                    <textarea
                      name="deliveryAddress"
                      value={orderForm.deliveryAddress}
                      onChange={handleOrderFormChange}
                      required
                      placeholder="Enter your complete delivery address (include area, landmark, city)"
                      rows={3}
                    ></textarea>
                    <div className="address-actions" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: '8px',
                      gap: '10px'
                    }}>
                      <button
                        type="button"
                        className="use-current-location-btn"
                        onClick={handleUseCurrentLocation}
                        disabled={isLocating}
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '8px 12px',
                          backgroundColor: '#f5f5f5',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          cursor: isLocating ? 'wait' : 'pointer',
                          fontSize: '14px',
                          color: '#333'
                        }}
                      >
                        {isLocating ? (
                          <>
                            <span className="location-spinner" style={{
                              display: 'inline-block',
                              width: '16px',
                              height: '16px',
                              border: '2px solid rgba(0, 0, 0, 0.1)',
                              borderTopColor: '#333',
                              borderRadius: '50%',
                              animation: 'spin 0.8s linear infinite',
                              marginRight: '8px'
                            }}></span>
                            Detecting...
                          </>
                        ) : (
                          <>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                              <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
                            </svg>
                            Use My Location
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                  {locationError && (
                    <div className="location-error" style={{
                      color: '#e53935',
                      fontSize: '13px',
                      marginTop: '5px',
                      padding: '5px',
                      backgroundColor: 'rgba(229, 57, 53, 0.1)',
                      borderRadius: '4px'
                    }}>
                      {locationError}
                    </div>
                  )}
                  <div className="address-helper" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                    💡 Tip: Include your area name, nearby landmark, and city for accurate delivery charges
                  </div>
                </div>
                <div className="payment-method-section2">
                  <h3>Payment Method</h3>
                  <div className="payment-options2">
                    <div className="payment-option2">
                      <label>
                        <div className="radio-container2">
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="online"
                            checked={orderForm.paymentMethod === 'online'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom2"></span>
                        </div>
                        <div className="payment-details2">
                          <div className="payment-name2">Online Payment</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="order-discounts-section">
                  <h3>Discounts & Rewards</h3>
                  {isLoggedIn && (
                    <div className="discount-option">
                      <label className="discount-checkbox">
                        <input
                          type="checkbox"
                          checked={usePointsDiscount}
                          onChange={handlePointsToggle}
                          disabled={availablePoints < 100}
                        />
                        <span>
                          Use loyalty points ({availablePoints} available)
                        </span>
                      </label>
                      {usePointsDiscount && pointsMessage && (
                        <div className="points-info">
                          {pointsMessage}
                        </div>
                      )}
                      {availablePoints < 100 && (
                        <div className="insufficient-points">
                          Minimum 100 points required to redeem
                        </div>
                      )}
                    </div>
                  )}
                  {calculateSubtotal() < FREE_DELIVERY_THRESHOLD && (
                    <div className="free-delivery-message" style={{ fontSize: '12px', color: 'green', marginTop: '10px' }}>

                    </div>
                  )}
                </div>
                <div className="price-summary2">
                  <div className="summary-row2">
                    <span>Subtotal:</span>
                    <span>₹{(product.price * quantity).toFixed(2)}</span>
                  </div>
                  {couponApplied && (
                    <div className="summary-row2 discount2">
                      <span>Coupon Discount (2%):</span>
                      <span>-₹{discountAmount.toFixed(2)}</span>
                    </div>
                  )}
                  {usePointsDiscount && pointsDiscountAmount > 0 && (
                    <div className="summary-row2 points-discount">
                      <span>Points Discount:</span>
                      <span>-₹{pointsDiscountAmount.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="summary-row2 delivery-charge" style={{
                    color: deliveryCharge === 0 ? 'green' : 'red',
                    fontSize: '14px'
                  }}>
                    <span>
                      Base Delivery Fee 
                      {isCalculatingDelivery && <span className="calculating-spinner"> 🔄</span>}
                    </span>
                    <span>
                      {deliveryCharge === 0 ? 'FREE' : `+₹${deliveryCharge.toFixed(2)}`}
                    </span>
                  </div>
                  {deliverySurcharge > 0 && (
                    <div className="summary-row2 delivery-surcharge" style={{
                      color: 'orange',
                      fontSize: '14px'
                    }}>
                      <span>Delivery Option Surcharge:</span>
                      <span>+₹{deliverySurcharge.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="summary-row2 total2">
                    <span>Total:</span>
                    <span>₹{totalAmount.toFixed(2)}</span>
                  </div>
                  <div className="summary-row2 points2">
                    <span>Points to be earned:</span>
                    <span>{pointsEarned} points</span>
                  </div>
                </div>
                {orderError && (
                  <div className="auth-error2">
                    {orderError}
                  </div>
                )}
                <button
                  type="submit"
                  className="place-order-btn2"
                  disabled={orderProcessing || isCalculatingDelivery}
                  style={{
                    opacity: (orderProcessing || isCalculatingDelivery) ? 0.6 : 1,
                    cursor: (orderProcessing || isCalculatingDelivery) ? 'not-allowed' : 'pointer'
                  }}
                >
                  {orderProcessing ? 'Processing...' : isCalculatingDelivery ? 'Calculating Delivery...' : 'Place Order'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
      {showBulkEnquiryModal && (
        <div className="modal-overlay2" onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}>
          <div className="bulk-enquiry-modal2" onClick={e => e.stopPropagation()}>
            <button
              className="modal-close-btn2"
              onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}
              disabled={bulkEnquirySubmitting || bulkEnquirySuccess}
            >
              ×
            </button>
            {bulkEnquirySuccess ? (
              <div className="enquiry-success2">
                <div className="success-icon2">✓</div>
                <h3>Enquiry Submitted Successfully!</h3>
                <p>We will contact you shortly with bulk pricing details.</p>
              </div>
            ) : (
              <>
                <div className="bulk-enquiry-header2">
                  <h2>Bulk Order Enquiry</h2>
                  <p>Please fill the form below for bulk pricing</p>
                </div>
                <div className="bulk-enquiry-quick-contact2">
                  <p>For immediate assistance:</p>
                  <a
                    href={`tel:${BULK_ENQUIRY_PHONE}`}
                    className="phone-contact-btn2"
                  >
                    <span className="phone-icon2">📞</span>
                    <span className="phone-number2">{BULK_ENQUIRY_PHONE}</span>
                  </a>
                  <button
                    className="whatsapp-contact-btn2"
                    onClick={handleDirectWhatsAppEnquiry}
                  >
                    <span className="whatsapp-icon2">💬</span>
                    <span>WhatsApp Now</span>
                  </button>
                </div>
                <form className="bulk-enquiry-form2" onSubmit={handleBulkEnquirySubmit}>
                  <div className="form-row2">
                    <div className="form-group2">
                      <label htmlFor="name">Full Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={bulkEnquiryForm.name}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="form-group2">
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={bulkEnquiryForm.email}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>
                  <div className="form-row2">
                    <div className="form-group2">
                      <label htmlFor="phone">Phone Number*</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={bulkEnquiryForm.phone}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="form-group2">
                      <label htmlFor="quantity">Estimated Quantity*</label>
                      <input
                        type="number"
                        id="quantity"
                        name="quantity"
                        min="10"
                        value={bulkEnquiryForm.quantity}
                        onChange={handleBulkEnquiryFormChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group2">
                    <label htmlFor="message">Additional Details</label>
                    <textarea
                      id="message"
                      name="message"
                      value={bulkEnquiryForm.message}
                      onChange={handleBulkEnquiryFormChange}
                      placeholder="Specify any special requirements or questions"
                      rows={3}
                    ></textarea>
                  </div>
                  {bulkEnquiryError && (
                    <div className="enquiry-error2">
                      {bulkEnquiryError}
                    </div>
                  )}
                  <button
                    type="submit"
                    className="submit-enquiry-btn2"
                    disabled={bulkEnquirySubmitting}
                  >
                    {bulkEnquirySubmitting ? 'Submitting...' : 'Submit Enquiry'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
      {showTimeCutoff && (
        <div className="modal-overlay2" onClick={closeTimeCutoffModal}>
          <div className="order-modal2" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px', textAlign: 'center' }}>
            <button className="modal-close-btn2" onClick={closeTimeCutoffModal}>×</button>
            <div style={{ padding: '20px' }}>
              <h3 style={{ marginBottom: '15px' }}>Process closed for today, book order tomorrow.</h3>
              <button
                onClick={closeTimeCutoffModal}
                style={{
                  backgroundColor: '#3c8c3e',
                  color: 'white',
                  border: 'none',
                  padding: '10px 30px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <FloatingActions />
    </div>
  );
};

export default ProductDetailsPage;
